import { getStateVariables as getStateVariablesBase } from '@akin-home/state-variables-frontend';
import { getUserChatID } from '@akin-home/user';
import { useStateStore } from '../../stores/useStateStore';
import { getUserChatAppID } from '../../users/functions';

/** Contains the context of current user and application id */
export const getStateVariables = (names: string[]) => {
  const { current_user } = useStateStore.getState();

  if (!current_user) return undefined;

  return getStateVariablesBase({
    application_id: getUserChatAppID(current_user),
    username: getUserChatID(current_user),
    names,
  });
};
